// extracted by mini-css-extract-plugin
module.exports = {"environment":"Login_environment__3pspF","environment__title":"Login_environment__title__N8Iu0","signupLabel":"Login_signupLabel__1IRbN","signupBtn":"Login_signupBtn__2usFd"};